import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Message } from '../../../../../../components'

// components
import JobDetail from './detail.component'
import JobForm from './form.component'

import './job.component.scss'

/**
 * Confirmation Modal
 * @param onClose
 * @param title
 * @param message
 * @param onDeleteConfirm
 * @returns {*}
 * @constructor
 */
const ConfirmModal = ({ onClose, title, message, onConfirm }) => {
  return (
    <Message
      visible
      type='warning'
      title={title}
      message={message}
      onClose={onClose}
      buttons={[
        {
          theme: 'shaded',
          label: 'cancel',
          onClick: onClose
        },
        {
          theme: 'citrus',
          label: 'confirm',
          onClick: () => onConfirm()
        }
      ]} />
  )
}

/**
 * Contact Jobs
 */
class Jobs extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      job: {},
      address: null,
      showJobForm: false,
      editJob: null
    }
  }

  /**
   * Opens contact job modal
   * @param job
   */
  onEdit = (job) => {
    const { searchInstitution } = this.props
    const id = job && job.value && job.value._id

    if (id) {
      this.setState({ editJob: id })

      searchInstitution(id).then((data) => {
        const address = (data && data.payload && data.payload.address) || null
        job.value = { ...job.value, address }

        this.setState({ job, showJobForm: true })
      })
    } else {
      this.setState({ showJobForm: true })
    }
  }

  /**
   * On job delete open confirmation modal
   * @param job
   */
  onDelete = (job) => {
    const { openModal } = this.props

    this.setState({ job })

    openModal({
      component: ({ onClose }) => ConfirmModal({
        onClose,
        title: 'Delete Institution?',
        message: 'Are you sure you want to delete this Institution?',
        onConfirm: this.onDeleteConfirm
      })
    })
  }

  /**
   * Delete selected job
   */
  onDeleteConfirm = () => {
    const { values, setFieldValue } = this.props
    const { job } = this.state
    const strategy = (job && job.strategy) || {};

    (values.jobs || []).splice(job.index, 1);
    values.strategy = (values.strategy || [])
      .filter((item) => (item && item.factset_entity_id !== strategy.factset_entity_id))

    setFieldValue(values.jobs)
    setFieldValue(values.strategy)
    !(values.jobs && values.jobs.length) && setFieldValue('managedFunds', [])

    this.onDeleteClose()
  }

  /**
   * On delete cancel close confirmation modal
   */
  onDeleteClose = () => {
    const { closeModal } = this.props

    this.setState({ job: {} })

    closeModal({
      component: ConfirmModal
    })
  }

  /**
   * Close contact job modal
   */
  onClose = () => {
    this.setState({ job: {}, showJobForm: false })
  }

  /**
   * Render
   * @return {*}
   */
  render () {
    const {
      values, searchInstitutions, loading, suggestions, clearSuggestions, setFieldValue, openModal, closeModal
    } = this.props
    const { job, showJobForm, editJob } = this.state

    return (
      <>
        <JobDetail
          jobs={values.jobs}
          strategy={values.strategy}
          onEdit={this.onEdit}
          onDelete={this.onDelete}
          editJob={editJob}
          loading={loading} />

        {showJobForm && <JobForm
          job={job}
          values={values}
          searchInstitutions={searchInstitutions}
          loading={loading}
          suggestions={suggestions}
          clearSuggestions={clearSuggestions}
          setFieldValue={setFieldValue}
          openModal={openModal}
          closeModal={closeModal}
          onClose={this.onClose} />}
      </>
    )
  }
}

Jobs.propTypes = {
  values: PropTypes.object.isRequired,
  searchInstitution: PropTypes.func.isRequired,
  searchInstitutions: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  suggestions: PropTypes.array,
  clearSuggestions: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired

}

Jobs.defaultProps = {
  values: {},
  suggestions: []
}

export default Jobs
